import { render } from "./AdminDashboardPage.vue?vue&type=template&id=3085eba0&scoped=true&ts=true"
import script from "./AdminDashboardPage.vue?vue&type=script&lang=ts"
export * from "./AdminDashboardPage.vue?vue&type=script&lang=ts"

import "./AdminDashboardPage.vue?vue&type=style&index=0&id=3085eba0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3085eba0"]])

export default __exports__